import { Injector, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PagesModule } from './pages/pages.module';
import { ComponentsModule } from './components/components.module';
import { HttpClientModule } from '@angular/common/http';
import { createCustomElement } from "@angular/elements";
import { APP_BASE_HREF } from '@angular/common';
import { NgbDatepickerModule, NgbProgressbarModule } from '@ng-bootstrap/ng-bootstrap';

import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { MockInterceptor } from './interceptors/inquilino.interceptor';
import { environment } from 'src/environments/environment';
import { AuthTokenSalesforceInterceptor } from './interceptors/auth.interceptor';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { metaReducers } from './tenant/storage/meta-reducers';
import { SarlaftInterceptor } from './interceptors/sarlaft.interceptor';
import { SharedModule } from './shared/shared.module'; // Import SharedModule
import { GeneralEffects } from 'src/storage/general.effects';

import { PreventScrollDirective } from './directives/prevent-scroll.directive';
import { CotizadorInterceptor } from './interceptors/cotizador.interceptor';
import { DevBypassHelperComponent } from './components/bypass-helper/bypass-helper-component';
import { authReducer } from 'src/storage/auth/auth.reduce';
import { AuthEffects } from 'src/storage/auth/auth.effects';

import { NewFlowModule } from './new-flow/newflow.module';

import { errorHandlerInterceptor } from './shared/interceptors/error-handler.interceptor';



@NgModule({
  declarations: [

    AppComponent,
     
  ],
  imports: [
    BrowserModule,
    NoopAnimationsModule,
    AppRoutingModule,
    PagesModule,
    ComponentsModule,
    NewFlowModule,
    HttpClientModule,
    NgbDatepickerModule,
    DevBypassHelperComponent,
    NgbProgressbarModule,
    // Configuración del Store con el reducer de auth
    StoreModule.forRoot({
      auth: authReducer
    }, { metaReducers }),
    // Configuración de Effects con AuthEffects y GeneralEffects
    EffectsModule.forRoot([
      GeneralEffects,
      AuthEffects
    ]),
    ...(environment.enableReduxDevTools
      ? [StoreDevtoolsModule.instrument({ maxAge: 25 })]
      : []),
    SharedModule, // Ensure SharedModule is imported
   
  ],
  providers: [
    { provide: APP_BASE_HREF, useValue: "/" },
    // Error handler interceptor siempre activo
    // { provide: HTTP_INTERCEPTORS, useValue: errorHandlerInterceptor, multi: true },
    (environment.useMockInterceptor ? [
      { provide: HTTP_INTERCEPTORS, useClass: MockInterceptor, multi: true },
      { provide: HTTP_INTERCEPTORS, useClass: AuthTokenSalesforceInterceptor, multi: true },
      { provide: HTTP_INTERCEPTORS, useClass: SarlaftInterceptor, multi: true },
      { provide: HTTP_INTERCEPTORS, useClass: CotizadorInterceptor, multi: true },

    ] : []),
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(private injector: Injector) {
    const appElement = createCustomElement(AppComponent, {
      injector: this.injector
    });
    customElements.define("arrendamientos-app", appElement);
  }
}